import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import { merchInitialValues } from 'components/organisms/forms/merch/MerchForm';
import { useHasPermission } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteMerch, useGetMerch } from 'services/merch';
import { getLastTabPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

export enum MerchTab {
  images,
}

const Merch = () => {
  const merchId = useParamId('merch');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const hasPermission = useHasPermission();

  const getMerch = useGetMerch(merchId);
  const deleteMerch = useDeleteMerch(merchId);

  const onRemoveMerch = async () => {
    await deleteMerch.mutateAsync(undefined, {
      onError: error => onErrorShowToast(error),
      onSuccess: () => navigate('/merch'),
    });
  };

  return (
    <Form.Merch
      status={{
        displayMode: true,
        isLoading: getMerch.isLoading,
        refetch: getMerch.refetch,
      }}
      i18nextPrefix='merch'
      initialValues={
        getMerch.data
          ? middleware.merch.queryToForm(getMerch.data)
          : merchInitialValues
      }
      onSubmit={() => {}}
      tittle={getMerch.data?.name ?? '-'}
      topbarContent={
        <div className='flex items-center gap-2'>
          {hasPermission('MerchPermissionsLIST**', 2) && (
            <Button
              isClear
              onlyIcon
              disabled={!getMerch.data}
              onClick={() => {
                getMerch.data &&
                  navigate(
                    `/merch/edit/${merchId}/${getLastTabPathname(pathname)}`,
                    {
                      replace: true,
                    }
                  );
              }}>
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          {hasPermission('MerchPermissionsLIST**', 4) && (
            <MagellanPopups.DeleteWarning
              name={getMerch.data?.name}
              onRemove={onRemoveMerch}
            />
          )}
        </div>
      }
    />
  );
};

export default Merch;
